import React from 'react';
import { css } from '@emotion/react';

import theme from '../../theme';

const OrderSummaryLine: React.FC = () => <div css={style} />;

const style = css`
    width: calc(100% - 20px);
    margin: 0 10px;
    height: 1px;
    background-color: ${theme.colours.grey[450]};
`;

export default OrderSummaryLine;
